<template>
	<div class="app-container">
		<!-- 面包屑导航区域 -->		<!-- 卡片视图区域 -->
		<el-card class="box-card">
			<!-- 搜索与添加区域 gutter设置两列之间的间距 -->
			<div style="margin-bottom: 15px;">
				<el-form ref="searchForm" :model="searchForm" label-width="70px" inline size="small">
					<el-form-item label="规则名称:">
						<el-input v-model="searchForm.ruleName" placeholder="请输入规则名称" clearable style="width: 180px;" />
					</el-form-item>
					<el-form-item label="规则类型:">
						<el-select v-model="searchForm.ruleType" placeholder="请选择规则类型" clearable style="width: 120px;">
							<el-option label="按比例分账" :value="1"></el-option>
							<el-option label="按固定金额分账" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="状态:">
						<el-select v-model="searchForm.isActive" placeholder="请选择状态" clearable style="width: 120px;">
							<el-option label="启用" :value="1"></el-option>
							<el-option label="禁用" :value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="handleSearch">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button @click="resetSearch">重置</el-button>
					</el-form-item>
          		<el-form-item>
						<el-button v-if="isSuperAuthority" type="primary" @click="handleAdd">+ 新增分账规则</el-button>
					</el-form-item>
				</el-form>
			</div>

			<!-- 分账规则列表区 -->
			<el-table :data="tableData" border stripe :header-cell-style="{ textAlign: 'center' }"
				:cell-style="{ textAlign: 'center' }">
				<el-table-column type="index" width="60"></el-table-column>
				<el-table-column prop="distributorName" label="运营商"></el-table-column>
				<el-table-column prop="ruleName" label="规则名称"></el-table-column>
				<el-table-column prop="ruleType" label="规则类型">
					<template slot-scope="scope">
						<span>{{ scope.row.ruleType === 1 ? '按比例分账' : '按固定金额分账' }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="isActive" label="状态">
					<template slot-scope="scope">
						<el-tag :type="scope.row.isActive === 1 ? 'success' : 'info'">
							{{ scope.row.isActive === 1 ? '启用' : '禁用' }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="isDefault" label="默认规则">
					<template slot-scope="scope">
						<el-tag :type="scope.row.isDefault === 1 ? 'success' : 'info'">
							{{ scope.row.isDefault === 1 ? '是' : '否' }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="description" label="描述"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
				<el-table-column fixed="right" header-align="center" align="center" width="200" label="操作">
					<template slot-scope="scope">
						<el-button v-if="isSuperAuthority" size="mini" type="primary" icon="el-icon-edit"
							@click="handleEdit(scope.row)">编辑</el-button>
						<el-button size="mini" type="primary" icon="el-icon-view"
							@click="handleViewDetails(scope.row)">查看明细</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页区域 -->
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="pagination.current" :page-sizes="[10, 20, 50, 100]"
				:page-size="pagination.size" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
			</el-pagination>
		</el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="运营商" prop="distributorId">
          <el-select v-model="form.distributorId" placeholder="请选择运营商" style="width: 100%" filterable
                     @change="handleDistributorChange" :disabled="!!form.id">
            <el-option
              v-for="item in distributorOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规则名称" prop="ruleName">
          <el-input v-model="form.ruleName" placeholder="请输入规则名称"></el-input>
        </el-form-item>
        <el-form-item label="规则类型" prop="ruleType">
          <el-select v-model="form.ruleType" placeholder="请选择规则类型" style="width: 100%">
            <el-option label="按比例分账" :value="1"></el-option>
            <el-option label="按固定金额分账" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="isActive">
          <el-radio-group v-model="form.isActive">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否为默认规则" prop="isDefault">
          <el-radio-group v-model="form.isDefault">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="规则描述" prop="description">
          <el-input type="textarea" v-model="form.description" placeholder="请输入规则描述"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" style="background-color: #3CA757; border-color: #3CA757;">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>


export default {
  name: 'SplitRuleManage',
  data() {
    return {
      searchForm: {
        ruleName: '',
        ruleType: null,
        isActive: null
      },
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新增分账规则',
      form: {
        id: '',
        distributorId: '',
        distributorName: '',
        ruleName: '',
        ruleType: 1,
        isActive: 1,
        isDefault: 0,
        description: ''
      },
      distributorOptions: [], // 运营商选项列表
      rules: {
        distributorId: [
          { required: true, message: '请选择运营商', trigger: 'change' }
        ],
        ruleName: [
          { required: true, message: '请输入规则名称', trigger: 'blur' }
        ],
        ruleType: [
          { required: true, message: '请选择规则类型', trigger: 'change' }
        ],
        isActive: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        isDefault: [
          { required: true, message: '请选择是否为默认规则', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.fetchData()
    this.fetchDistributorOptions()
    this.initCurrentRoleCode();
  },
  methods: {
    initCurrentRoleCode() {
      const roleCodes = JSON.parse(window.sessionStorage.getItem('roleCodes') || '[]')
      const roles = JSON.parse(window.sessionStorage.getItem('roles') || '[]')
      this.isSuperAuthority = roleCodes.includes('SUPER_AUTHORITY') || roles.some(role => role.roleCode === 'SUPER_AUTHORITY')
    },
    fetchData() {
      const requestData = {
        page: this.pagination.current,
        limit: this.pagination.size,
        ruleName: this.searchForm.ruleName,
        ruleType: this.searchForm.ruleType,
        isActive: this.searchForm.isActive
      }
      this.$http.post('/split/rule/page', requestData).then(response => {
        if (response.data.code === 200) {
          this.tableData = response.data.data.list
          this.pagination.total = response.data.data.total
        } else {
          this.$message.error(response.data.msg || '获取数据失败')
        }
      }).catch(error => {
        this.$message.error('获取数据失败')
      })
    },
    handleSearch() {
      this.pagination.current = 1
      this.fetchData()
    },
    resetSearch() {
      this.searchForm = {
        ruleName: '',
        ruleType: null,
        isActive: null
      }
      this.handleSearch()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this.fetchData()
    },
    handleAdd() {
      this.dialogTitle = '新增分账规则'
      this.form = {
        id: '',
        distributorId: '',
        distributorName: '',
        ruleName: '',
        ruleType: 1,
        isActive: 1,
        isDefault: 0,
        description: ''
      }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.dialogTitle = '编辑分账规则'
      this.form = { ...row }
      this.dialogVisible = true
    },
    handleDelete(row) {
      this.$confirm('确认删除该分账规则吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.get(`/split/rule/delete/${row.id}`).then(response => {
          if (response.data.code === 200) {
            this.$message.success('删除成功')
            this.fetchData()
          } else {
            this.$message.error(response.data.msg || '删除失败')
          }
        }).catch(error => {
          this.$message.error('删除失败')
        })
      })
    },
    handleViewDetails(row) {
      this.$router.push({
        path: '/distributor/splitRuleDetail',
        query: { ruleId: row.id }
      })
    },
    submitForm() {
      // 编辑时，移除运营商字段的必填验证
      const rulesToValidate = { ...this.rules }
      if (this.form.id) {
        delete rulesToValidate.distributorId
      }
      
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.id) {
            // 更新操作，传递完整表单数据
            this.$http.post('/split/rule/update', this.form).then(response => {
              if (response.data.code === 200) {
                this.$message.success('更新成功')
                this.dialogVisible = false
                this.fetchData()
              } else {
                this.$message.error(response.data.msg || '更新失败')
              }
            }).catch(error => {
              this.$message.error('更新失败')
            })
          } else {
            // 新增操作，不传递id字段
            const { id, ...formData } = this.form
            this.$http.post('/split/rule/add', formData).then(response => {
              if (response.data.code === 200) {
                this.$message.success('保存成功')
                this.dialogVisible = false
                this.fetchData()
              } else {
                this.$message.error(response.data.msg || '保存失败')
              }
            }).catch(error => {
              this.$message.error('保存失败')
            })
          }
        }
      }, rulesToValidate)
    },
    handleDialogClose() {
      this.$refs.form.resetFields()
    },
    // 获取运营商选项列表
    fetchDistributorOptions() {
      this.$http.get('/distributor/manager/getAllDistributorInfo').then(response => {
        if (response.data.code === 200) {
          this.distributorOptions = response.data.data
        } else {
          this.$message.error(response.data.msg || '获取运营商列表失败')
        }
      }).catch(error => {
        this.$message.error('获取运营商列表失败')
      })
    },
    // 处理运营商选择变化
    handleDistributorChange(value) {
      const selectedDistributor = this.distributorOptions.find(item => item.id === value)
      if (selectedDistributor) {
        this.form.distributorName = selectedDistributor.name
      }
    }
  }
}
</script>

<style scoped>
.breadcrumb {
  margin-bottom: 20px;
}

.box-card {
}

.filter-container {
  margin-bottom: 20px;
}

.filter-container .el-form-item {
  margin-bottom: 0;
}

.btn-container {
  margin-bottom: 20px;
}

.pagination-container {
  text-align: right;
}
</style>